import { convertDateToLocaleString } from "./convertDates";

/**
 * Sets a date to UTC midnight.
 *
 * @param s - The initial string or date
 * @param tomorrow - Boolean - positive to set to the next midnight, negative for the previous midnight
 */
export const setToUTCMidnight = (s: string | Date, tomorrow?: boolean): string => {
  const date = s instanceof Date ? s : new Date(s);
  if (!isNaN(date.getTime())) {
    /* istanbul ignore else */
    if (tomorrow) date.setDate(date.getDate() + 1);
    date.setUTCHours(0, 0, 0, 0);
    return convertDateToLocaleString(date);
  } else {
    console.warn(`Invalid date: ${s}`);
    return "";
  }
};
